import CartButton from "../../components/Cart/CartButton";
import Sidebar, {
  SidebarPersistenceContext,
} from "../../components/Layouts/Sidebar";
import Toaster from "../../components/Layouts/Toaster/Toaster";
import LoginModal from "../../components/Login-UI/LoginModal";
import ToastNotification from "../../components/VerticalPlayer/components/Notification/Notification";
import { useLoginModalContext } from "../context/LoginModal";
import { useNotification } from "../context/Notification";
import React, { useMemo } from "react";
import { Outlet } from "react-router-dom";
import { AppRouteContextProvider } from "../context/AppRouteContext";
import { useSdkInitialization } from "../hooks/useSdkInitialization";
import { useTemplateRouting } from "../hooks/useTemplateRouting";

const AppShell = () => {
  const storedValue = localStorage.getItem("defaultLanguage");
  const { showLoginModal, setShowLoginModal } = useLoginModalContext();
  const { notification, closeNotification } = useNotification();

  const {
    pathname,
    selectedFeedTemplateType,
    selectedTemplateType,
    selectedSdkTemplateType,
  } = useTemplateRouting();

  useSdkInitialization({
    pathname,
    selectedSdkTemplateType,
  });

  const shouldUsePersistentSidebar = useMemo(() => {
    const routesWithoutSidebar = new Set([
      "/",
      "/sign-up",
      "/sign-in",
      "/forgot-password",
      "/gluedin-login",
      "/create-post",
      "/create-post-page-02",
      "/create-text",
      "/creator",
    ]);
    return !routesWithoutSidebar.has(pathname);
  }, [pathname]);
  const shouldShowSidebarProfile = pathname !== "/my-profile";

  return (
    <div
      className="App"
      id="direction"
      dir={storedValue === "ar" ? "rtl" : "ltr"}
    >
      <CartButton />
      <SidebarPersistenceContext.Provider value={shouldUsePersistentSidebar}>
        {shouldUsePersistentSidebar && (
          <div className="app-shell-sidebar">
            <Sidebar
              persistentRoot={true}
              showProfile={shouldShowSidebarProfile}
            />
          </div>
        )}
        <AppRouteContextProvider
          value={{
            selectedFeedTemplateType,
            selectedTemplateType,
            selectedSdkTemplateType,
          }}
        >
          <Outlet />
        </AppRouteContextProvider>
      </SidebarPersistenceContext.Provider>
      <LoginModal
        show={showLoginModal}
        handleClose={() => setShowLoginModal(false)}
      />
      {notification.show && (
        <ToastNotification
          show={notification.show}
          title={notification.title}
          subTitle={notification.subTitle}
          type={notification.type}
          onClose={closeNotification}
        />
      )}
      <Toaster />
    </div>
  );
};

export default AppShell;
